import React from 'react';
import { PropTypes } from 'prop-types';
import { StyledExpansionPanel } from './Accordion.styles';

function Accordion(props) {
  const { defaultExpanded, fullWidth, children, transitionProps, expanded, onChange } = props;

  return (
    <StyledExpansionPanel
      TransitionProps={transitionProps}
      defaultExpanded={defaultExpanded}
      fullWidth={fullWidth}
      expanded={expanded}
      onChange={onChange}
    >
      {children}
    </StyledExpansionPanel>
  );
}

Accordion.propTypes = {
  defaultExpanded: PropTypes.bool,
  fullWidth: PropTypes.bool,
  children: PropTypes.node.isRequired,
  transitionProps: PropTypes.shape({}),
  expanded: PropTypes.bool,
  onChange: PropTypes.func
};

Accordion.defaultProps = {
  defaultExpanded: false,
  fullWidth: true,
  transitionProps: {},
  expanded: undefined,
  onChange: undefined
};
export default Accordion;
